import { makeAsyncAction } from '../../../ui-lottery';
import * as types from '../constants/actions';
import * as api from '../api';

export const generateApiKey = makeAsyncAction(
  types.GENERATE_APIKEY,
  () => () => api.generateApiKey(),
  'api_key'
);
